
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SaveOrPreviewButtons extends Vue {    

    @Prop({required: false, default:true})
    textBelow!: boolean;

    @Prop({required: true})
    expiredDeadline!: boolean;

    mounted() {
                       
    }  

    public saveForm1(state){
        this.$emit('saveForm1',state);
    }
}
